import React, { useState } from 'react';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import '@progress/kendo-theme-default/dist/all.css';
import { Pagination } from 'antd';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import AccountTable from './Common/AccountTable';

import SelectList from './Common/SelectList';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const AccountStatement = ({ isShow, setIsShow }) => {
    const acTable = [
        {
            Sno: 1,
            member: 'Raj(673763763)',
            pkg: 'Weight Gain',
            cDate: '2078-11-02',
            cAmt: 12050,
        },
        {
            rAmt: 1500,
            bAmt: 10550,
            rDate: '2078-11-02',
            invoice: 'w|456',
            rNo: 'r|008',
        },
        {
            Sno: 2,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 3,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 4,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 5,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 6,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 7,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 8,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 9,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 10,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
        {
            Sno: 11,
            member: 'Raju(673763763)',
            pkg: 'Weight Loss',
            cDate: '2078-11-02',
            cAmt: 2000,
        },
        {
            rAmt: 1000,
            bAmt: 1000,
            rDate: '2078-11-05',
            invoice: 'w|457',
            rNo: 'r|009',
        },
    ];

    const [data, setData] = useState(acTable);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dataRef = React.createRef();

    const calculateCharge = () => {
        let charge = 0;
        for (let item of acTable) {
            charge += item.cAmt ? item.cAmt : 0
        }
        return charge;
    };

    const calculateReceipt = () => {
        let receipt = 0;
        for (let item of acTable) {
            receipt += item.rAmt ? item.rAmt : 0
        }
        return receipt;
    };

    const calculateRemain = () => {
        let remain = 0;
        for (let item of acTable) {
            remain += item.bAmt ? item.bAmt : 0
        }
        return remain;
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <div className='page_first_div '>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>Account Statement Details</p>
                <section className='page_section min-h-[23rem]'>
                    <h3 className='font-bold underline px-4 xsm:px-8 pt-3'>Member Details</h3>
                    {/* Selectors,Inputs,SearchBar */}
                    <form className='flex flex-col justify-center px-4 xsm:px-8 lg:flex-row 2xl:justify-start items-center flex-wrap gap-4 py-4 '>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector  w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Member--</option>
                                <option value="Maria" className=''>Maria</option>
                                <option value="Hemant">Hemant</option>
                                <option value="Rajiv">Rajiv</option>
                                <option value="Sharan">Sharan</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Enrollment Package--</option>
                                <option value="Weight Loss" >Weight Loss</option>
                                <option value="Weight Gain">Weight Gain</option>
                            </select>
                        </div>
                        <div className='font-lato text-sm xsm:text-base w-full lg:w-80'>
                            <DatePicker placeholder='Expiry Date' format="dd MMMM yyyy" className="date_picker" />
                        </div>
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </form>

                    {/* Balance Details */}
                    <div className='flex px-4 gap-2 sm:gap-0 xsm:px-8 py-3 flex-wrap'>
                        <div className='font-bold border-2 text-center px-4 py-2 basis-full sm:text-left lg:text-lg sm:basis-4/12'>
                            Charge Amount:- {calculateCharge()}
                        </div>
                        <div className='font-bold border-2 text-center px-4 py-2 basis-full sm:text-left lg:text-lg sm:basis-4/12'>
                            Receipt Amount:- {calculateReceipt()}
                        </div>
                        <div className='font-bold border-2 text-center px-4 py-2 basis-full sm:text-left lg:text-lg sm:basis-4/12'>
                            Remaining Balance:- {calculateRemain()}
                        </div>
                    </div>

                    {/* show option and convert buttons */}
                    <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
                        <SelectList
                            setPostPerPage={setPostPerPage}
                            data={data}
                        />
                        <ConvertButtons
                            ref={dataRef}
                            data={data}
                        />
                    </div>

                    {/* Account Statement Table */}
                    <AccountTable
                        data={currentPost}
                        searchTerm={searchTerm}
                        ref={dataRef}
                    />

                    {/* Showing table length with Pagination */}
                    <div className='px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>

                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AccountStatement;